import { render, staticRenderFns } from "./WorkplanDescription.vue?vue&type=template&id=067f6f8e&scoped=true"
import script from "./WorkplanDescription.vue?vue&type=script&lang=ts"
export * from "./WorkplanDescription.vue?vue&type=script&lang=ts"
import style0 from "./WorkplanDescription.vue?vue&type=style&index=0&id=067f6f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067f6f8e",
  null
  
)

export default component.exports